import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['Tags'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      tagsGetCollectionAsyncByqueryOptions: build.query<
        TagsGetCollectionAsyncByqueryOptionsApiResponse,
        TagsGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Tags`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Tags'],
      }),
      tagsGetAsyncByid: build.query<
        TagsGetAsyncByidApiResponse,
        TagsGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/Tags/${queryArg.id}` }),
        providesTags: ['Tags'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type TagsGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 Tag entities response */ ReadTagDto[];
export type TagsGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>TagId</strong> (default), <strong>Text</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>TagId</strong> (default), <strong>Text</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type TagsGetAsyncByidApiResponse =
  /** status 200 Tag entities response */ ReadTagDto;
export type TagsGetAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type AccountNoRefsDto = {
  AccountId: number;
  Name: string;
  Address: string;
  BillingAddress?: string;
};
export type UnitNoRefsDto = {
  UnitId: number;
  Name: string;
  Description?: string;
  Latitude?: number;
  Longitude?: number;
  GpsAccuracy?: number;
};
export type ReadTagDto = {
  TagId: number;
  Text: string;
  Account: AccountNoRefsDto;
  Units?: UnitNoRefsDto[];
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type ErrorResult4 = ErrorResult;
export const {
  useTagsGetCollectionAsyncByqueryOptionsQuery,
  useLazyTagsGetCollectionAsyncByqueryOptionsQuery,
  useTagsGetAsyncByidQuery,
  useLazyTagsGetAsyncByidQuery,
} = injectedRtkApi;
